import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-projects",
  "use": "svg_menu-projects-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" id=\"svg_menu-projects\"><path d=\"M1 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M0 2a2 2 0 0 1 2-2h2a3 3 0 0 1 3 3v1H0V2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol